import ReactGA from 'react-ga4';

// Initialize Google Analytics
export const initGA = (measurementId) => {
  if (measurementId && measurementId !== 'YOUR_GA_MEASUREMENT_ID') {
    ReactGA.initialize(measurementId, {
      gaOptions: {
        siteSpeedSampleRate: 100,
      },
    });
    console.log('Google Analytics initialized with ID:', measurementId);
  } else {
    console.warn('Google Analytics Measurement ID not configured');
  }
};

// Track page views
export const logPageView = () => {
  const path = window.location.pathname + window.location.search;
  ReactGA.send({ hitType: 'pageview', page: path });
  console.log('Page view logged:', path);
};

// Track events
export const logEvent = (category, action, label = '', value = 0) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
    value: value,
  });
};

// Track custom events (more flexible)
export const trackEvent = (eventName, eventParams = {}) => {
  ReactGA.event(eventName, eventParams);
};

// Track outbound links
export const trackOutboundLink = (url, label = '') => {
  logEvent('Outbound Link', 'Click', label || url);
};

// Track form submissions
export const trackFormSubmission = (formName) => {
  logEvent('Form', 'Submit', formName);
};

// Track button clicks
export const trackButtonClick = (buttonName, location = '') => {
  logEvent('Button', 'Click', `${buttonName}${location ? ` - ${location}` : ''}`);
};

// Track downloads
export const trackDownload = (fileName) => {
  logEvent('Download', 'Click', fileName);
};

// Track user timing
export const trackTiming = (category, variable, time, label = '') => {
  ReactGA.gtag('event', 'timing_complete', {
    name: variable,
    value: time,
    event_category: category,
    event_label: label,
  });
};
